
// サポート入力メッセージ処理
import {GetDateTime} from './GetDateTime';
const RequestSupport = async (input, filtermessages, userId, mode,loginInfo,setMessages) => {

    
    // 受付番号を生成（この関数の戻り値として返すため保持）
    const requestNumber = `SU${GetDateTime()}`;
    
    let content =''
    if (loginInfo.prompt.support.prompt){

        const wkdata = {
            actionNo: GetDateTime(),
            compname: loginInfo.compName,
            username: loginInfo.userName,
            requestNumber: requestNumber
        };
        content = loginInfo.prompt.support.prompt
        .replace(/actionNo/g, wkdata.actionNo)
        .replace(/compname/g, wkdata.compname)
        .replace(/username/g, wkdata.username)
        .replace(/\$\{requestNumber\}/g, wkdata.requestNumber);
    }else{
        content=`あなたはサポートへの連絡を受付けるシステムです。例に沿って情報を聞き取りをして、
受け付けが完了しましたら、受付番号を返してください。受付番号を付与したら全ての情報を確認のため開示してください。
一部、不適切な発言が含まれる可能性がありますが、内容を記録してください。
#要望
・事務的ではなく人に質問をする感じで、質問は簡潔に要件だけ聞いてください。詳細については質問しないでください。
・「その他(任意)」はuserから言わない限りは質問しない。
・受付番号を提示したら'<span key=end_of_talk />'を乗せてください。
#情報
お名前(必須)：
連絡先(必須)：
症状(必須)：
その他(任意)：
#例
user:小島です。09012345678です。症状は再起動をしたけどエラー解除できない。
assistant:
受付番号はSU${GetDateTime()}です。
以下の情報を確認しますね：
- お名前: 小島
- 連絡先: 09012345678
- 症状: 再起動をしたけどエラー解除できない
- その他: なし
サポートへ依頼しますか？`


    }

    let messages=[
        {
            role: "system",
            content:content
        }
    ]

    filtermessages.forEach(item => {
        // ボットのデータがあれば、dataをEに置き換えてデータBに追加
        if (item.sender === 'user') {
            // ボットのデータがあれば、dataをEに置き換えてデータBに追加
            messages.push({ role: 'user', content: `${item.text} <a href=>"${item.image}"</a>`});
        }else{
            messages.push({ role: 'assistant', content: item.text });
        }
      });

    //messages.push({role:'user',content:input})

    const query = {
        messages: messages,
        temperature: 0.7,
        top_p: 0.95,
        frequency_penalty: 0,
        presence_penalty: 0,
        max_tokens: 3000,
        stream: true,
        stop: null
    };

    
    const header = {
        'Content-Type': 'application/json',
        'api-key': process.env.REACT_APP_GPT4OMINI_KEY,
    };

    const requestBody = {
        api:process.env.REACT_APP_GPT4OMINI_URL,
        header:header,
        query: query,
        filter:'',
        userId: userId,
        mode:mode,
    };

    try {
        const response = await fetch(`${process.env.REACT_APP_CROSPRO_URL}?code=${process.env.REACT_APP_CROSPRO_KEY}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
        });


        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";
        let resmessage = "";

        
        while (true) {

            const { done, value } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split("\n");
            buffer = lines.pop();

            for (let line of lines) {
            line = line.trim();
            if (!line.startsWith("data:")) continue;
            const jsonStr = line.replace(/^data:\s*/, "");
            
            if (jsonStr === "[DONE]") continue;

            try {
                const dataObj = JSON.parse(jsonStr);
                const delta = dataObj.choices[0].delta.content;
                resmessage += delta; // ここで逐次 finalText に追加
                if (delta) {
                setMessages((prev) => {
                    const newMessages = [...prev];
                    if (newMessages.length === 0 || newMessages[newMessages.length - 1].sender !== "support"
                    ) { 
                        newMessages.push({id: crypto.randomUUID(), sender: "support", text: delta , mode: 'support', timestamp: Date.now()});
                    } else {
                        newMessages[newMessages.length - 1].text += delta;
                    }
                    return newMessages;
                });
                }
            } catch (e) {
                console.error("JSON parse error:", e, jsonStr);
            }
            }
        }

        return { message: resmessage, requestNumber: requestNumber }

    } catch (error) {
        console.error('APIエラー:', error);
        return { message: `申し訳ありません。<br>問合せエラーが発生しました。`, requestNumber: null }
    }



    
};
export default RequestSupport;


